// Documento: Como crear un flujo con botones
// Categoría: Flujos
// Última actualización: 2024-12-28

const document = {
  "id": "crear-flujo-botones",
  "title": "Como crear un flujo con botones",
  "category": "Flujos",
  "description": "Aprende a crear flujos con botones para controlar mejor la experiencia del usuario. Los botones permiten opciones claras, mejor navegación y múltiples acciones como enviar mensajes, abrir sitios web y ejecutar acciones automáticas.",
  "explanations": [
    {
      "title": "¿Por qué usar botones en los flujos?",
      "content": "Los botones nos permiten controlar el flujo de una mejor manera, ofreciendo a los usuarios opciones claras y específicas. En lugar de esperar que el usuario escriba una respuesta, los botones proporcionan una experiencia más guiada y profesional, reduciendo la posibilidad de errores y mejorando la usabilidad del chatbot."
    },
    {
      "title": "Limitaciones de los botones",
      "content": "La cantidad máxima de botones son 3 por bloque. Esta limitación está diseñada para mantener una interfaz limpia y evitar abrumar al usuario con demasiadas opciones simultáneamente. Si necesitas más de 3 opciones, considera dividir las opciones en múltiples pasos o usar otros elementos como respuestas rápidas."
    },
    {
      "title": "Acciones disponibles para botones",
      "content": "Los botones pueden realizar distintas acciones:\n\n• **Enviar mensajes:** Continuar con el flujo enviando el usuario a otro paso\n• **Abrir sitios web:** Dirigir al usuario a una URL externa\n• **Realizar acciones:** Ejecutar acciones como agregar etiquetas, establecer campos personalizados, etc.\n• **Ejecutar flujos:** Iniciar otros flujos de conversación\n• **Transferir a humano:** Derivar la conversación a un asesor\n\nTodas estas opciones son listadas al abrir el menú del botón durante la configuración."
    },
    {
      "title": "Personalización de botones",
      "content": "Los botones pueden tener texto personalizado y emojis, lo que permite crear una experiencia más atractiva y visualmente clara. Los emojis pueden ayudar a identificar rápidamente la función de cada botón y hacer la interfaz más amigable y moderna."
    },
    {
      "title": "Video tutorial",
      "content": "Para una demostración visual completa del proceso, consulta el video tutorial disponible. Nota: Estamos trabajando en implementar la funcionalidad de reproducción de videos directamente en la documentación para mejorar la experiencia de aprendizaje.",
      "video": "https://drive.google.com/file/d/1WJF_ZkumOoKOJIeYnPswVRoaXLtii-Qo/view?usp=drive_link"
    }
  ],
  "steps": [
    {
      "title": "Acceder a Flujos",
      "content": "Primero, dirígete a la sección de Flujos desde el menú principal de Runamatic. Esta es donde gestionarás todos tus flujos de conversación automatizados."
    },
    {
      "title": "Crear un nuevo flujo",
      "content": "Haz clic en \"Crear nuevo flujo\" o \"Añadir\" para comenzar a construir tu flujo con botones. Dale un nombre descriptivo que te ayude a identificar su propósito."
    },
    {
      "title": "Añadir contenido de tipo texto",
      "content": "En el constructor de flujos, agrega un bloque de contenido de tipo \"Texto\". Este será el mensaje que acompañará a tus botones, proporcionando contexto o instrucciones al usuario sobre las opciones disponibles."
    },
    {
      "title": "Configurar el mensaje de texto",
      "content": "Escribe el mensaje que quieres mostrar antes de los botones. Por ejemplo: \"¿En qué puedo ayudarte hoy?\" o \"Selecciona una de las siguientes opciones:\". Este mensaje debe ser claro y dirigir al usuario hacia las opciones de los botones."
    },
    {
      "title": "Añadir botones al bloque",
      "content": "Una vez que tengas tu mensaje de texto configurado, busca la opción para \"Añadir botones\" en el bloque de texto. Esto te permitirá agregar hasta 3 botones por bloque."
    },
    {
      "title": "Configurar cada botón individualmente",
      "content": "Para cada botón que agregues:\n- Define el texto que aparecerá en el botón\n- Agrega emojis si deseas (opcional pero recomendado)\n- Selecciona la acción que realizará el botón del menú desplegable\n- Configura los parámetros específicos según la acción elegida"
    },
    {
      "title": "Probar y publicar el flujo",
      "content": "Una vez configurados todos los botones, utiliza la función de vista previa para probar cómo se ve y funciona tu flujo. Asegúrate de que cada botón realice la acción esperada, luego publica el flujo para que esté disponible para tus usuarios."
    }
  ],
  "tags": [
    "botones",
    "flujos",
    "navegación",
    "experiencia-usuario",
    "automatización",
    "interfaz"
  ],
  "lastUpdated": "2024-12-28",
  "difficulty": "básico"
};

export default document;
